var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Button, Checkbox, FormControl, FormHelperText, Grid, InputAdornment, Paper, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useFormik } from 'formik';
import * as yup from 'yup';
import { ApTextFieldGridItem } from "../../shared/components/forms/ApTextFieldGridItem";
import { ApAutocompleteGridItem } from "../../shared/components/forms/ApAutocompleteGridItem";
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ReCAPTCHA from "react-google-recaptcha";
import SignupApi from "./signup-api/signup-api";
import { FormConstants } from "../../shared/components/forms/Constants";
import FormControlLabel from "@mui/material/FormControlLabel";
import AddIcon from '@mui/icons-material/Add';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { enqueueSnackbar } from "notistack";
import { errorSnackbar } from "../../shared/snackbar-constants";
import { getErrorMessage } from "../../utilities/axios-utility";
import LoadingButton from "@mui/lab/LoadingButton";
var MonthlySales = [
    // {value: "", label: 'Monthly sales'},
    { value: "2500", label: 'Less than € 5,000' },
    { value: "10000", label: '€ 5,000 to € 15,000' },
    { value: "25000", label: '€ 15,000 to € 35,000' },
    { value: "50000", label: '€ 35,000 to € 75,000' },
    { value: "95000", label: '€ 70,000 to € 125,000' },
    { value: "150000", label: '€ 125,000 +' },
];
var validationSchema = yup.object({
    countryCode: yup.string().required(FormConstants.FieldIsRequired).nullable(),
    email: yup.string().email().required(FormConstants.FieldIsRequired),
    fullName: yup.string().required(FormConstants.FieldIsRequired),
    url: yup.string().url().required(FormConstants.FieldIsRequired),
    history: yup.boolean().required(FormConstants.FieldIsRequired),
    volume: yup.string().required(FormConstants.FieldIsRequired).oneOf(["2500", "10000", "25000", "50000", "95000", "150000"]).nullable(),
    isTermsSubmitted: yup.boolean().required("The terms and conditions must be accepted.")
        .oneOf([true], "The terms and conditions must be accepted."),
    isVerifiedCaptcha: yup.boolean().oneOf([true], "The Captcha must be accepted.").required(),
});
export var SignupPage = function (_a) {
    var countries = _a.countries, captcha = _a.captcha;
    var api = new SignupApi();
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var emptyCompanyInfo = {
        countryCode: "",
        fullName: "",
        history: false,
        url: "",
        volume: "",
        email: "",
        isVerifiedCaptcha: false,
        isTermsSubmitted: false,
    };
    var countriesData = JSON.parse(countries);
    var formik = useFormik({
        initialValues: emptyCompanyInfo,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: function (values) { return __awaiter(void 0, void 0, void 0, function () {
            var model, response, message, div, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        model = {
                            url: values.url,
                            countryCode: values.countryCode,
                            email: values.email,
                            volume: values.volume,
                            history: values.history,
                            fullName: values.fullName,
                            isVerifiedCaptcha: values.isVerifiedCaptcha,
                            isTermsSubmitted: values.isTermsSubmitted
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        setLoading(true);
                        return [4 /*yield*/, api.Signup(model)];
                    case 2:
                        response = _a.sent();
                        if (response.data.success) {
                            window.location.href = response.data.redirectUrl;
                            setLoading(false);
                        }
                        else {
                            setLoading(false);
                            message = response.data.message;
                            div = _jsx("div", { dangerouslySetInnerHTML: { __html: message } });
                            enqueueSnackbar(div, errorSnackbar);
                        }
                        setLoading(false);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        enqueueSnackbar(getErrorMessage(error_1), errorSnackbar);
                        setLoading(false);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); }
    });
    var onChangeCaptcha = function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var response, data, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, api.verifyCaptcha(value)];
                case 1:
                    response = _a.sent();
                    data = JSON.parse(response.data);
                    return [4 /*yield*/, formik.setFieldValue("isVerifiedCaptcha", data.success)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    enqueueSnackbar(getErrorMessage(error_2), errorSnackbar);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var onSubmit = function () {
        formik.handleSubmit();
    };
    return (_jsx(Box, __assign({ component: Paper, sx: { padding: 3, width: '556px' } }, { children: _jsxs(Grid, __assign({ spacing: 2, container: true, alignItems: "center" }, { children: [_jsxs(Grid, __assign({ item: true, xs: 12 }, { children: [_jsx(Typography, __assign({ sx: { paddingTop: 2, paddingLeft: 2, display: 'flex', justifyContent: 'center' }, variant: "h6", noWrap: true, component: "div" }, { children: "SIGNUP TO ARETO PAYMENT" })), _jsx("br", {})] })), _jsx(ApAutocompleteGridItem, { formik: formik, name: 'countryCode', options: countriesData.map(function (f) { return ({
                        value: f.alpha2,
                        label: f.name
                    }); }), size: "small", label: 'Country of Incorporation', xs: 12, fullWidth: true }), _jsx(ApAutocompleteGridItem, { formik: formik, name: 'volume', options: MonthlySales.map(function (f) { return ({
                        value: f.value,
                        label: f.label
                    }); }), size: "small", label: 'Monthly sales', xs: 12, fullWidth: true }), _jsx(ApTextFieldGridItem, { name: 'fullName', label: 'Full Name', placeholder: "Enter your full name", formik: formik, xs: 12, foolWidth: true, inputProps: {
                        endAdornment: _jsx(InputAdornment, __assign({ position: "end" }, { children: _jsx(HowToRegIcon, {}) })),
                    }, size: "small" }), _jsx(ApTextFieldGridItem, { name: 'email', label: 'Email', formik: formik, placeholder: "Enter your email", xs: 12, foolWidth: true, inputProps: {
                        endAdornment: _jsx(InputAdornment, __assign({ position: "end" }, { children: _jsx(AlternateEmailIcon, {}) })),
                    }, size: "small" }), _jsx(ApTextFieldGridItem, { name: 'url', label: 'Website URL. eg. https://example.com ', formik: formik, xs: 12, foolWidth: true, inputProps: {
                        endAdornment: _jsx(InputAdornment, __assign({ position: "end" }, { children: _jsx(ShoppingCartIcon, {}) })),
                    }, placeholder: "https://example.com", size: "small" }), _jsx(Grid, __assign({ item: true, xs: 12 }, { children: _jsx(FormControlLabel, { sx: { margin: '3px' }, control: _jsx(Checkbox, { sx: { '& .MuiSvgIcon-root': { fontSize: 30 } }, checked: formik.values.history, onChange: formik.handleChange, name: "history" }), label: 'Have you ever accepted payments on your website?' }) })), _jsx(Grid, __assign({ item: true, xs: 12 }, { children: _jsxs(FormControl, { children: [_jsx(FormControlLabel, { sx: { margin: '3px' }, control: _jsx(Checkbox, { sx: { '& .MuiSvgIcon-root': { fontSize: 30 } }, checked: formik.values.isTermsSubmitted, "aria-errormessage": 'requiredTerms-helper', onChange: formik.handleChange, name: "isTermsSubmitted" }), label: 'Accept terms of service' }), _jsx(FormHelperText, __assign({ "aria-label": "requiredTerms-helper", error: formik.touched.isTermsSubmitted && Boolean(formik.errors.isTermsSubmitted) }, { children: (formik.touched.isTermsSubmitted && formik.errors.isTermsSubmitted) || " " }))] }) })), _jsx(Grid, __assign({ item: true, xs: 12 }, { children: _jsxs(FormControl, { children: [_jsx(ReCAPTCHA, { sitekey: captcha, onChange: onChangeCaptcha }), _jsx(FormHelperText, __assign({ error: formik.touched.isVerifiedCaptcha && Boolean(formik.errors.isVerifiedCaptcha) }, { children: (formik.touched.isVerifiedCaptcha && formik.errors.isVerifiedCaptcha) || " " }))] }) })), _jsx(Grid, __assign({ item: true, xs: 12 }, { children: _jsxs(Box, __assign({ display: "flex", justifyContent: "flex-end" }, { children: [_jsx(Button, __assign({ sx: { textTransform: "none" }, variant: "text", color: 'info', startIcon: _jsx(KeyboardBackspaceIcon, {}), href: '/signin' }, { children: "SignIn" })), _jsx(LoadingButton, __assign({ sx: { textTransform: "none" }, loading: loading, onClick: onSubmit, loadingPosition: "end", endIcon: _jsx(AddIcon, {}), variant: "contained", color: "success" }, { children: "SignUp" }))] })) }))] })) })));
};
